export enum UpcomingFilterText {
  AllUpcoming = 'All upcoming',
  PresigningToday = 'Signing today',
  PresigningTomorrow = 'Signing tomorrow'
}
